import { render, staticRenderFns } from "./TechnologyIcon.vue?vue&type=template&id=2a0db382&"
import script from "./TechnologyIcon.vue?vue&type=script&lang=ts&"
export * from "./TechnologyIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports